export default {
  props: { warehouseId: { type: [String, Number], required: true } },
  data() {
    return { target: '', place: null, label: '', review: false, linked: false,
      busy: false, error: '', recent: [], generation: 0 };
  },
  watch: {
    warehouseId() { this.reset(); this.recent = []; },
    target() { if (!this.place) this.generation += 1; },
    label() { this.review = false; },
  },
  beforeUnmount() { this.generation += 1; },
  methods: {
    reset() {
      this.generation += 1; this.target = ''; this.place = null; this.label = '';
      this.review = false; this.linked = false; this.error = '';
    },
    async selectLocation() {
      if (this.busy || !this.warehouseId || !this.target) return;
      const generation = this.generation;
      this.busy = true; this.error = '';
      try {
        const place = await this.$service.storagePlace.identifierRequest({
          action: 'resolve', raw: this.target, warehouse: this.warehouseId,
        });
        if (generation !== this.generation) return;
        this.place = place; this.label = ''; this.review = false; this.linked = false;
      } catch (error) {
        if (generation === this.generation) this.error = error.message;
      } finally { this.busy = false; }
    },
    selectSearchResult(item) {
      if (this.busy) return;
      this.reset(); this.target = item.internalCode;
      this.$nextTick(() => this.selectLocation());
    },
    reviewMapping() {
      if (!this.busy && this.place && this.label && !this.linked) this.review = true;
    },
    async confirmMapping() {
      if (this.busy || !this.review || !this.place || !this.label || this.linked) return;
      const generation = this.generation;
      const raw = this.label;
      const place = this.place;
      this.busy = true; this.error = '';
      try {
        await this.$service.storagePlace.identifierRequest({ action: 'add',
          warehouse: this.warehouseId, place: place.uuid || place.id, raw });
        if (generation !== this.generation) return;
        this.recent = [{ raw, internalCode: place.internalCode }, ...this.recent].slice(0, 20);
        this.linked = true; this.review = false;
        this.$emit('linked');
      } catch (error) {
        if (generation === this.generation) this.error = error.message;
      } finally { this.busy = false; }
    },
    anotherLabel() {
      if (this.busy) return;
      this.label = ''; this.review = false; this.linked = false; this.error = '';
    },
    async handleBarcode(scan) {
      if (this.busy) return;
      const raw = typeof scan === 'string' ? scan : (scan.originalRaw ?? scan.raw);
      if (typeof raw !== 'string' || !raw) return;
      if (this.linked || this.review) {
        this.error = this.$t('Finish this mapping before scanning another label'); return;
      }
      if (!this.place) {
        this.target = raw;
        await this.$nextTick();
        await this.selectLocation();
        return;
      }
      this.label = raw;
      await this.$nextTick();
      this.reviewMapping();
    },
  },
};
